<template>
    <div class="min-h-40 sm:min-h-80 md:py-20 py-10 ">
      <div class="lg:text-5xl md:text-3xl text-2xl text-[#C6C6C6] font-sans font-bold">Hello,I'm Mini!</div>
      <div class="lg:text-5xl md:text-3xl text-2xl text-[#C6C6C6] font-sans font-bold flex ">I make websites
        <div class="slidingVertical">
          <span
            class="bg-gradient-to-r from-[#9627FF] to-[#19F4DA] inline-block text-transparent bg-clip-text indent-2">beautiful</span>
          <span
            class="bg-gradient-to-r from-[#9627FF] to-[#19F4DA] inline-block text-transparent bg-clip-text indent-2">performant</span>
          <span
            class="bg-gradient-to-r from-[#9627FF] to-[#19F4DA] inline-block text-transparent bg-clip-text indent-2">faster</span>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HeroSection',
}
</script>